import * as React from "react";

export default class Hover extends React.Component<{
    onMouseOut: () => any,
    onMouseOver: () => any,
}, { hover: boolean }> {
    public constructor(props) {
        super(props);
        this.state = {
            hover: false,
        };
    }

    public render() {
        return <span
            onMouseOut={() => this.setState({ hover: false })}
            onMouseOver={() => this.setState({ hover: true })}
        >
            {this.state.hover ? this.props.onMouseOver() : this.props.onMouseOut()}
        </span>;
    }
}
